import { render, staticRenderFns } from "./FSIDailyreportDetention.vue?vue&type=template&id=e6eea252&scoped=true"
import script from "./FSIDailyreportDetention.vue?vue&type=script&lang=js"
export * from "./FSIDailyreportDetention.vue?vue&type=script&lang=js"
import style0 from "./FSIDailyreportDetention.vue?vue&type=style&index=0&id=e6eea252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6eea252",
  null
  
)

export default component.exports